import { useSelector } from 'react-redux'
import { selectAuthData } from '@/containers/Login/AuthSelectors'

const useOverviewRedesign = (): boolean => useSelector(selectAuthData)?.commonData?.overviewRedesignEnabled === true

export default useOverviewRedesign
